@if (isActive) {
  <topo-modal
    [isActive]="isActive"
    [backgroundCanClose]="true"
    [isCard]="true"
    (close)="onClose()"
    [width]="1024"
    (contentScrolled)="contentScrolled()"
    [removeHeaderBottomPadding]="true">
    <div class="modal-header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <h5 class="mx-4 my-4">{{ title }}</h5>
        <div
          fxLayout="row"
          fxLayoutAlign="space-between center">
          <button
            class="button is-primary is-small mr-5"
            (click)="exportToExcel()">
            <span class="icon material-icons is-left">file_download</span>
            <span>{{ 'MANAGEMENT.DATASETS.EXPORT' | translate }}</span>
          </button>
          <div
            class="dialog-close"
            (click)="onClose()">
            <i class="icon icon-close-X"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div>
        @if (isEmailTemplate) {
          <div>
            <div class="label">{{ 'MAP.SUBJECT' | translate }}</div>
            <div class="mb-2">
              <input
                type="text"
                class="input is-medium"
                name="subject"
                [(ngModel)]="subject" />
            </div>
            <div class="separator"></div>
          </div>
        }
        <div class="label">{{ 'MAP.MESSAGE-TAB' | translate }}</div>
        <div
          class="box design-section"
          fxLayout="column"
          style="margin: 0px">
          <div
            style="height: 100%"
            class="design-surface-container"
            fxLayout="row"
            fxLayoutAlign="center start">
            <div
              class="box design-section design-surface-container design-surface is-readonly is-multiline"
              [innerHtml]="body | safeHtml"
            [style.white-space]="isPlainText ? 'pre' : 'normal'"></div>
          </div>
        </div>
        <!-- Recipients Table -->
        <topo-table
          [showHeader]="false"
          headerLabel="{{ 'MAP.RECIPIENTS-TAB' | translate }}"
          [showNewItem]="false"
          itemName="{{ 'MANAGEMENT.DATAFEEDS.DATAFEED' | translate }}"
          [items]="recipients"
          [totalCount]="recipients?.length"
          [showPager]="false"
          [showSearch]="false">
          <topo-columns>
            <topo-column label="{{ 'MAP.RECIPIENT-COLUMN-RECIPIENT' | translate }}">
              <ng-template let-recipient="item">
                <div style="line-height: 2rem">
                  {{ recipient.recipient }}
                </div>
              </ng-template>
            </topo-column>
            <topo-column label="{{ 'MAP.RECIPIENT-COLUMN-NAME' | translate }}">
              <ng-template let-recipient="item">
                {{ recipient.name }}
              </ng-template>
            </topo-column>
            <topo-column label="{{ 'MAP.RECIPIENT-COLUMN-DISTRIBUTION-LIST' | translate }}">
              <ng-template let-recipient="item">
                {{ recipient.distributionListName }}
              </ng-template>
            </topo-column>
            <topo-column label="{{ 'MAP.RECIPIENT-COLUMN-TYPE' | translate }}">
              <ng-template let-recipient="item">
                {{ 'MAP.RECIPIENT-TYPE-' + recipient.recipientType | translate }}
              </ng-template>
            </topo-column>
            <topo-column label="{{ 'MAP.RECIPIENT-COLUMN-STATUS' | translate }}">
              <ng-template let-recipient="item">
                {{ 'MAP.COMMUNICATION-RECIPIENT-STATUS-' + recipient.status | translate }}
              </ng-template>
            </topo-column>
          </topo-columns>
        </topo-table>
        <div class="mb-5"></div>
      </div>
    </div>
    <div class="modal-footer">
      <div
        fxLayout="row"
        fxLayoutAlign="end"
        class="mt-4 mb-4">
        @if (!!communication?.massNotificationUId) {
          <div
            style="margin-right: 10px">
            <button
              class="button is-secondary"
              (click)="logClick()">
              {{ 'APP.EXCEPTION-LOG' | translate }}
            </button>
          </div>
        }
        <div style="margin-right: 5px">
          <button
            class="button is-secondary"
            (click)="cancelClick()">
            {{ 'APP.CLOSE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </topo-modal>
}

<topo-comms-notification-log
  [notification]="logNotification"
  [configuredChannelUId]="configuredChannelUId"
(logClosed)="onLogClosed()"></topo-comms-notification-log>
